module.exports = __webpack_public_path__ + "static/media/strip-tablet-user-progress-maths-desk.1a4a0a97.png";